import { useState, useEffect, useCallback } from "react";
import { Property, fetchProperties, fetchProperty } from "@/data/properties";

export function useProperties() {
  const [properties, setProperties] = useState<Property[]>([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchProperties();
      setProperties(data);
    } catch (e) {
      console.error("Error loading properties:", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const available = properties.filter((p) => p.estado === "disponible");
  const featured = properties.filter((p) => p.destacada && p.estado === "disponible");

  return { properties, available, featured, loading, reload };
}

export function useProperty(id: string | null) {
  const [property, setProperty] = useState<Property | null>(null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    if (!id) { setProperty(null); setLoading(false); return; }
    setLoading(true);
    try {
      const data = await fetchProperty(id);
      setProperty(data);
    } catch (e) {
      console.error("Error loading property:", e);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => { reload(); }, [reload]);

  return { property, loading, reload };
}